const NonZeroValidator = (value) => {
  if(parseFloat(value) == 0.0) {
    return false;
  }
  return true;
}

const NonEmptyValidator = (value) => {
  if(value == 'not-available' || value == '' || value == undefined) {
    return false;
  }
  return true;
}

const NonEmptyArrayValidator = (value) => {
  if(!Array.isArray(value) || value.length === 0) {
    return false;
  }
  return true;
}

// A count that may be zero but never negative -- used by the fire adeti (wastage count) fields.
// An empty field is left valid: these fields default to 0 and carry no NonEmptyValidator, so a
// blank input means "0", not an error.
const NonNegativeValidator = (value) => {
  if(value === '' || value === undefined || value === null) {
    return true;
  }
  return parseFloat(value) >= 0;
}

const ValidatorFactory = (validatorName, value) => {
  const validators = {
    NonZeroValidator: NonZeroValidator,
    NonEmptyValidator: NonEmptyValidator,
    NonEmptyArrayValidator: NonEmptyArrayValidator,
    NonNegativeValidator: NonNegativeValidator,
  }
  const SpecificValidator = validators[validatorName];
  return SpecificValidator(value);
}

export {
  NonZeroValidator,
  NonEmptyValidator,
  NonEmptyArrayValidator,
  NonNegativeValidator,
  ValidatorFactory
};
